/** Bearer 토큰·401 세션 정리를 건너뛸 인증 API (로그인·관제 비밀번호 등) */
const CREDENTIAL_FREE_AUTH_FRAGMENTS = [
  '/api/auth/login',
  '/api/auth/register',
  '/api/auth/refresh',
  '/api/auth/admin/password/verify',
  '/api/auth/reset-password',
  '/password/verify',
] as const;

export function isCredentialFreeAuthRequest(url?: string): boolean {
  const u = url ?? '';
  return CREDENTIAL_FREE_AUTH_FRAGMENTS.some((frag) => u.includes(frag));
}
